<app-breadcrumb></app-breadcrumb>

<!-- <report-car-temper-summary [inputSelectedDate]="selectedDate"></report-car-temper-summary> -->

<div class="card mb-0 mt-3" style="height: calc(100% - 140px);">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="검색어"
                        [(ngModel)]="searchValue"
                        (keyup.enter)="keyupEnterSearchValue($event)">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickSearch()">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="searchDtgCarType"
                    (ngModelChange)="changeCarType($event)">
                    <option *ngFor="let item of dtgCarTypeList;" [ngValue]="item.dtgCarType">{{item.dtgCarTypeNm}}</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedYear"
                    (ngModelChange)="changeYear($event)">
                    <option *ngFor="let item of listYear;" [ngValue]="item">{{item}} 년</option>
                </select>
            </div>
            <div class="col-auto">
                <select class="form-control form-control-sm"
                    [(ngModel)]="selectedMonth"
                    (ngModelChange)="changeMonth($event)">
                    <option *ngFor="let item of listMonth;" [ngValue]="item">{{item}} 월</option>
                </select>
            </div>
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-sm btn-outline-success"
                    (click)="exportExcel()">
                    <i class="fas fa-file-excel"></i>
                    <span class="ml-1">엑셀출력</span>
                </button>
            </div>
        </div>

        <div class="table-responsive mt-3" style="height: calc(100% - 75px);">
            <table class="table table-sm table-hover align-items-center mb-0 text-nowrap">
                <thead>
                    <tr class="text-center">
                        <th>
                            차량번호
                        </th>
                        <th>
                            구분
                        </th>
                        <th>
                            운행시간
                        </th>
                        <th>
                            온도1(최소/최대)
                        </th>
                        <th>
                            온도2(최소/최대)
                        </th>
                        <th>
                            장비명
                        </th>
                        <th>
                            운행일지
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!listItem || listItem.length < 1">
                        <tr class="text-center">
                            <td colspan="7">
                                표시 할 항목이 없습니다
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngFor="let item of listItem;let idx = index;">
                        <tr class="text-center">
                            <td>
                                <button type="button" class="btn btn-sm btn-link text-cyan">
                                    {{item.dtgCarNo}}
                                </button>
                            </td>
                            <td>
                                {{item.dtgCarTypeNm}}
                            </td>
                            <td>
                                {{item.dtgRegDtDuration | filterSecToTime}}
                            </td>
                            <td>
                                {{(item.dtgTemper1From * 0.1) | number:'0.1'}}
                                /
                                {{(item.dtgTemper1To * 0.1) | number:'0.1'}}
                            </td>
                            <td>
                                {{(item.dtgTemper2From * 0.1) | number:'0.1'}}
                                /
                                {{(item.dtgTemper2To * 0.1) | number:'0.1'}}
                            </td>
                            <td>
                                -
                            </td>
                            <td>
                                <button type="button" class="btn btn-sm btn-link text-cyan"
                                    [routerLink]="['/','dtg','report','car','temper','daily',item.dtgUnitId,selectedYear,selectedMonth]">
                                    <i class="far fa-file-alt"></i>
                                    확인
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>

<div class="text-warning bg-white shadow-sm p-2 mt-3 small">
    <div class="">
        <i class="far fa-bell mr-2"></i>
        <span>페이지 진입시 데이터가 자동으로 표시되지 않으며 검색버튼을 눌러야 표시됩니다</span>
    </div>
</div>